import { Locale } from '../i18n/index.js';
import * as uuid from 'uuid';
import { SYSTEM_ROLES_MAP } from './role.const.js';
export const GUEST = {
    _id: uuid.NIL,
    title: 'Guest',
    locale: Locale.en,
    roles: [SYSTEM_ROLES_MAP.guest._id],
    active: true,
    deleted: false,
};
export const UUID_NIL = uuid.NIL;
